import { render } from "./Tools.vue?vue&type=template&id=897ae60c&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import "./Tools.vue?vue&type=style&index=0&id=897ae60c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897ae60c"]])

export default __exports__